import { Record, List } from 'immutable';

const defaultValues = {
  sourceOpcoId: '',
  sourceCustomerId: '',
  destinationOpcoId: '',
  destinationCustomerId: '',
  transferType: '',
  initiatedBy: 0,
  id: 0,
  endTime: '',
  status: '',
  firstName: '',
  startTime: '',
  transferNote: null,
};

export default class AssetTransfer extends Record(defaultValues, AssetTransfer) {
  constructor(values) {
    super({
      ...values,
    });
  }
}

export const AssetTransfers = (data) => {
  let assetTransfer = new List();
  if (data) {
    data.forEach((value) => {
      assetTransfer = assetTransfer.push(new AssetTransfer(value));
    });
  }
  return assetTransfer;
};
